import styled, { css } from 'styled-components';

/**
 * One billing banner, laid out like the tablet's: a rounded strip, a round
 * "!" on the left, the text, and the action on the right (under the text on
 * a phone). Red tint for critical, yellow for warning - the Callout tints.
 */
export const BannerSurface = styled.div<{
  $critical: boolean;
  $clickable: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  color: ${({ theme }) => theme.darkGray};
  background: ${({ $critical, theme }) =>
    $critical
      ? theme.transparentRed
      : `${theme.yellow}${theme.transparency.t15}`};

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
    `}

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
  }

  @media (max-width: 800px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

/** The round "!" at the start of a banner. */
export const BannerIcon = styled.span<{ $critical: boolean }>`
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  color: ${({ theme }) => theme.white};
  background: ${({ $critical, theme }) =>
    $critical ? theme.primary : theme.yellow};
`;

/** Title and message; takes the room the icon and the action leave. */
export const BannerText = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 800px) {
    flex-basis: calc(100% - 48px);
  }
`;

/** The action: right of the text, full width under it on a phone. */
export const BannerAction = styled.div`
  flex: none;

  @media (max-width: 800px) {
    width: 100%;
  }
`;
